// extracted by mini-css-extract-plugin
export default {"triangleIcon":"DraggableVisit_triangleIcon__U+Q8I","talkIcon":"DraggableVisit_talkIcon__sq6ln"};